import { AppCardBoxLoader, AppNotFoundBox } from "../../../../Libraries";
import { getSubCategoryById } from "../../../../../api";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { CreateSubCategory } from "..";

const EditSubCategory = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState({});

    useEffect(() => {
        if (id) getSubCategory();
        else setLoading(false);
    }, [id]);

    const getSubCategory = async () => {
        try {
            const { data } = await getSubCategoryById(id);
            setItem(data.subCategory);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    };


    return loading ?
        <AppCardBoxLoader />
        : item?._id ?
            <CreateSubCategory from="edit" item={item} />
            :
            <AppNotFoundBox title='failed_to_load_sub_category' />
};

export default EditSubCategory;